var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7101_46056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99967 10L5.33301 11.3333L8.33301 8.33333M5.33301 5.33333V3.46667C5.33301 2.71993 5.33301 2.34656 5.47833 2.06134C5.60616 1.81046 5.81014 1.60649 6.06102 1.47866C6.34624 1.33333 6.7196 1.33333 7.46634 1.33333H12.533C13.2797 1.33333 13.6531 1.33333 13.9383 1.47866C14.1892 1.60649 14.3932 1.81046 14.521 2.06134C14.6663 2.34656 14.6663 2.71993 14.6663 3.46667V8.53333C14.6663 9.28007 14.6663 9.65344 14.521 9.93865C14.3932 10.1895 14.1892 10.3935 13.9383 10.5213C13.6531 10.6667 13.2797 10.6667 12.533 10.6667H10.6663M3.46634 14.6667H8.53301C9.27974 14.6667 9.65311 14.6667 9.93833 14.5213C10.1892 14.3935 10.3932 14.1895 10.521 13.9387C10.6663 13.6534 10.6663 13.2801 10.6663 12.5333V7.46667C10.6663 6.71993 10.6663 6.34656 10.521 6.06134C10.3932 5.81046 10.1892 5.60649 9.93833 5.47866C9.65311 5.33333 9.27974 5.33333 8.53301 5.33333H3.46634C2.7196 5.33333 2.34624 5.33333 2.06102 5.47866C1.81014 5.60649 1.60616 5.81046 1.47833 6.06134C1.33301 6.34656 1.33301 6.71993 1.33301 7.46667V12.5333C1.33301 13.2801 1.33301 13.6534 1.47833 13.9387C1.60616 14.1895 1.81014 14.3935 2.06102 14.5213C2.34624 14.6667 2.7196 14.6667 3.46634 14.6667Z",
    stroke: "#667BA3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7101_46056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDoneIcon);
export default __webpack_public_path__ + "static/media/check-done-icon.1e07d58025731a84bfe2eaf179639d45.svg";
export { ForwardRef as ReactComponent };